<template>
    <section
        class="flex"
        :class="'bg-' + background"
    >
        <div
            class="section-inner flex width"
            :class="'section-width-' + width"
        >
            <slot></slot>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            width: {
                type: String,
                required: false,
                default: 'sm'
            },
            background: {
                type: String,
                required: false,
                default: 'white'
            }
        }
    }
</script>
